import GenericController from './../generic.controller'

export default class Controller extends GenericController {

    constructor(...args) {

        super(...args);
        this.stateDescription = {
            battery_low: this.gettext('battery_low'),
            monitor_alarm: this.gettext('monitor_mode'),
            silent: this.gettext('silent_mode'),
            tamper_alarm: this.gettext('tamper_alarm'),
            tamper_open: this.gettext('tamper_open'),
            ready: this.gettext('ready'),
        };
        this.stateList = [this.gettext('battery_low'), this.gettext('monitor_alarm'), this.gettext('silent'), this.gettext('tamper_alarm')];
        this.CONNECTION_TEXT = [this.gettext('Turn on'), this.gettext('Turn off')];
        this._statisticGraphChartBindToName = 'outputChart';
        this.outputs = null;
        this.$scope.currentPromise = this.getOutputs();
        // todo: implement specific output tamper ws event
        this.newReportEventReference = this.$rootScope.$on('newReport', (e, event) => {

            if (event.hasOwnProperty('data')) {
                if (event.data.hasOwnProperty('text')) {
                    if (_.includes(event.data.text.toLowerCase(), 'output')) {
                        this.getOutputs();
                        this.$scope.$apply();
                    }
                }
            }
        });

        this.tamper = this.$rootScope.$on('tamper', (e, eventObj) => {
            this._onSocketEventUpdateZoneAttribute(eventObj, 'tamper_alarm', 'Zone', this._findOutput.bind(this)); //todo: check why Zone instead of Output
        });

        this.socketEventReference = this.$rootScope.$on('socketEvent', (e, event) => {
            this.getOutputs();
        });

        this.$element.on('$destroy', () => {

            this.closeModal('AcPlugStatisticsModal');
            this.closeModal('outputGraphModal');
            this.closeModal('GenericStatisticsModal');
            this.newReportEventReference();
            this.tamper();
            this.socketEventReference();
        });

    }

    _findOutput(outputId) {
        return _.find(this.outputs, {'id': outputId})
    }

    getDeviceDescription(id) {
        let deviceType = this.DEVICE_TYPE[id];
        if (deviceType) {
            return deviceType.deviceTypeDescription;
        } else {
            return 'Unknown device type';
        }
    }

    getOutputs() {

        return super.getOutputsConfigList()
            .then(resp => {
                this.outputs = resp;
            })
            .catch(() => {
            });

    }

    setOutputName(outputObj) {
        this.askUserCode()
            .then(userCode => {
                if (userCode) {
                    this.ModalDialogService.isModalClosed = true;
                    if (outputObj.name) {
                        this.$scope.currentPromise = this._PanelsService.changePanelOutput(this.panelId, outputObj, userCode).then(resp => {
                            this.popMessage(outputObj.name + ' ' + this.updateOKText);
                            let output = resp.data;
                            _.merge(this.outputs, output);
                            this.UserCodeService.saveUserCode(userCode);
                        }).finally(this.ModalDialogService.isModalClosed = false)
                    } else {
                        this.$state.reload();
                    }
                }
            }).catch(() => {
            this.$state.reload();
        });
    }

    toggleOutput(output) {
        this.$scope.currentPromise = super.setOutput(this.panelId, output.id, !output.state)
            .then(resp => {
                output.state = resp.state;

            });

    }

    getState(output) {

        let stateList = '';
        let openText = null;

        for (let stateOption of this.stateList) {
            if (stateOption == 'state' && output[stateOption] == true) {
                openText = this.getTranslatableText('Open');
            }
            if (output[stateOption] == true) {
                stateList += this.$filter('humanize')(this.getTranslatableText(stateOption)) + ', ';
            }
        }

        if (openText) {
            stateList = openText + ', ' + stateList;
        }

        return stateList.slice(0, -2);
    }

    loadChosenGraph(graphTypeStr, offset = 0) {
        this.showModal('outputGraphModal');
        this._setTimeoutGraphLoading(graphTypeStr, offset, this.getDectOutputMeasurements);
    }

    loadGenericStatisticsChosenGraph(graphTypeStr, offset = 0) {
        this.showModal('outputGraphModal');
        this._setTimeoutGraphLoading(graphTypeStr, offset, this.getOutputGenericStatisticsMeasurements);
    }

}


/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/outputs.component/controller.js
 **/